import { RequestHeaders } from "./request-headers";
import { environment } from "../../../../environments/environment";

export const GetItem = async (itemType, itemId, itemSetter) => {
  const defaultErrorHandler = (error) => {
    // TODO
  };

  fetch(`${environment.apiBaseUrl}${itemType}/${itemId}`, {
    method: 'GET',
    headers: await RequestHeaders.get()
  })
    .then(res => {
      if (res.ok) {
        res.json().then(data => {
          itemSetter(data)
        })
      }
    })
    .catch(defaultErrorHandler)
}
